import './home.css';

import {AraSamtavrobo} from './arasamtavrobo/AraSamtavrobo';
import {Video} from './video/Video';
import {Article} from './article/Article';
import {Geo} from './geo/Geo.jsx';


export function Home (){
    return(
        <div className="home">
            <Geo />
            <AraSamtavrobo />
            <Article />
            <Video />
        </div>
    )
}